<template>
  <header class="py-0" :class="type === 'form-ext' ? 'header ext' : 'header'">
    <div style="height: auto; width:100%; display: flex;">
      <img
        v-if="color === 'white'"
        src="../assets/att_hz_lg_lkp_rgb_wht.png"
        alt="AT&T Logo"
      />
      <img
        v-if="color === 'black'"
        style="margin-left: -1.5rem"
        src="../assets/att_hz_lg_lkp_rgb_pos.png"
        alt="AT&T Logo"
      />
      <div
        id="lang_toggle"
        v-if="type === 'form' || type === 'form-ext'"
        class="toggle_container"
      >
        <label
          v-show="!spanishDisabled && !englishDisabled"
          for="language-switch"
          style="display:flex; margin: 0px !important;"
        >
          <button
            class="clickable"
            :disabled="spanishDisabled || selected_language.code === 'es'"
            @click="setLang('es')"
          >
            Español
          </button>
          &nbsp;
          <div class="vl"></div>
          &nbsp;
          <button
            class="clickable"
            :disabled="englishDisabled || selected_language.code === 'en'"
            @click="setLang('en')"
          >
            English
          </button>
        </label>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: {
    color: String,
    type: String,
    spanishDisabled: {
      type: Boolean,
      default: false,
    },
    englishDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toggle_checked: null,
      selected_language: null,
      languages: [
        {
          code: "en",
          name: "English",
        },
        {
          code: "es",
          name: "Spanish",
        },
      ],
    };
  },
  computed: {
    labelFont() {
      return this.color === "white" ? { color: "white" } : { color: "#25303a" };
    },
    toggleDisabled() {
      return this.englishDisabled || this.spanishDisabled;
    },
  },
  created() {
    if (this.englishDisabled) {
      this.selected_language = {
        code: "es",
        name: "Spanish",
      };
      this.toggle_checked = true;
      this.$emit("lang", this.selected_language);
    } else if (this.spanishDisabled) {
      this.selected_language = {
        code: "en",
        name: "English",
      };
      this.toggle_checked = false;
      this.$emit("lang", this.selected_language);
    } else if (this.$route.query.lang) {
      this.selected_language = this.languages.find(
        (obj) => this.$route.query.lang.toLowerCase() === obj.code
      );
      // if no selected language was found to match the query param, set it to english
      this.selected_language = !this.selected_language
        ? this.languages[0]
        : this.selected_language;

      this.toggle_checked = this.selected_language.code !== "en";
      this.setLanguage();
    } else if (localStorage.getItem("lang")) {
      this.selected_language = this.languages.find(
        (obj) => localStorage.getItem("lang") === obj.code
      );
      this.toggle_checked = this.selected_language.code !== "en";
      this.setLanguage();
    } else {
      this.selected_language = this.languages[0];
      localStorage.setItem("lang", this.selected_language.code);
      this.toggle_checked = this.selected_language.code !== "en";
      this.$emit("lang", this.selected_language);
    }
  },
  methods: {
    setLanguage() {
      localStorage.setItem("lang", this.selected_language.code);
      this.$emit("lang", this.selected_language.code);
    },
    setLang(lang) {
      this.selected_language = this.languages.find((obj) => lang === obj.code);
      this.setLanguage();
    },
  },
};
</script>

<style scoped>
.toggle_container {
  display: flex;
  align-items: center;
  z-index: 1;
  margin-left: auto;
  margin-right: 0;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 0;
  max-height: 90px;
}

.ext {
  padding: 2.5vh 0vw;
}

.header p {
  font-size: 1.4rem;
  margin: 0;
  font-weight: 500;
}

.header img {
  width: 9.5rem;
  z-index: 1;
}

.multiselect {
  width: unset;
  z-index: 1;
}

.multiselect .multiselect__option--highlight {
  background: gray !important;
  outline: none;
  color: white;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: gray !important;
  outline: none;
  color: white;
}

p.toggle-label {
  font-size: 1.7rem;
  color: #111;
  font-weight: 300;
}

.vl {
  border-left: 1px solid black;
  height: 25px;
}

.clickable {
  text-decoration: inherit;
  background: none;
  border: none;
  color: black;
}

.clickable:hover {
  text-decoration: underline;
  cursor: pointer;
}

.clickable:hover:disabled {
  text-decoration: None !important;
  cursor: default;
}
</style>
